module.exports = __webpack_public_path__ + "static/logo-rs-946a0cc3104fce8e92dcd2fb7e340038.svg";